/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityDocumentTypes
 */
export interface IdentityDocumentTypes {
    /**
     * 
     * @type {Array<string>}
     * @memberof IdentityDocumentTypes
     */
    documentTypes: Array<string>;
}

/**
 * Check if a given object implements the IdentityDocumentTypes interface.
 */
export function instanceOfIdentityDocumentTypes(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentTypes" in value;

    return isInstance;
}

export function IdentityDocumentTypesFromJSON(json: any): IdentityDocumentTypes {
    return IdentityDocumentTypesFromJSONTyped(json, false);
}

export function IdentityDocumentTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityDocumentTypes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentTypes': json['document_types'],
    };
}

export function IdentityDocumentTypesToJSON(value?: IdentityDocumentTypes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_types': value.documentTypes,
    };
}

